import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initGlobalMotion(): void {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    // Page load fade-in - skipped for hash entries so anchor positioning stays stable.
    if (window.location.hash) {
        gsap.set('#main', { opacity: 1, y: 0, clearProps: 'transform' });
    } else {
        gsap.fromTo('#main',
            { opacity: 0, y: 16 },
            {
                opacity: 1,
                y: 0,
                duration: 1.1,
                ease: 'power3.out',
                delay: 0.05,
                onComplete: () => gsap.set('#main', { clearProps: 'transform' })
            }
        );
    }

    // Global reveal animations - fire early, play once (no reverse to avoid missed elements)
    document.querySelectorAll('[data-reveal]').forEach((el) => {
        if (el.getAttribute('data-reveal') === 'lines') {
            // Staggered per-child reveal - used by hero copy blocks
            const lines = Array.from(el.children);
            gsap.set(el, { opacity: 1, clearProps: 'transform' });
            gsap.fromTo(lines,
                { opacity: 0, y: 26 },
                {
                    opacity: 1, y: 0,
                    duration: 0.85, ease: 'power3.out',
                    stagger: 0.1,
                    scrollTrigger: {
                        trigger: el,
                        start: 'top 96%',
                        toggleActions: 'play none none none',
                        once: true
                    }
                }
            );
            return;
        }

        gsap.fromTo(el,
            { opacity: 0, y: 22 },
            {
                opacity: 1, y: 0,
                duration: 0.85, ease: 'power2.out',
                scrollTrigger: {
                    trigger: el,
                    start: 'top 96%',
                    toggleActions: 'play none none none',
                    once: true
                }
            }
        );
    });

    // Recalculate after full page load (fonts, images)
    window.addEventListener('load', () => ScrollTrigger.refresh());
}

export function initParallax(selector: string, y: number = 50): void {
    gsap.to(selector, {
        y: y,
        scrollTrigger: {
            trigger: selector,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
        }
    });
}
